// @flow

import type { IncomingPayment } from './types';
import type { AchPseInfo } from '@tectonics/prs/incoming-payment/payment-option';

function getAchPseInfo(incomingPayment: IncomingPayment): ?AchPseInfo {
  return incomingPayment['ach_pse'];
}

export function getSafeAchPseInfo(incomingPayment: IncomingPayment): AchPseInfo {
  const achPseInfo = getAchPseInfo(incomingPayment);

  if (!achPseInfo)
    throw new Error('Voucher: no voucher in incoming payment');

  return achPseInfo;
}
